import { useLocale } from '@mirai/locale';
import { Notification, Progress, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { CONTAINER_ID, LANGUAGES, SCRIPT_ID, SCRIPT_URL } from './FormPaynopain.constants';
import { L10N } from './FormPaynopain.l10n';
import * as style from './FormPaynopain.module.css';
import { loadScript } from '../../../../../helpers/loadScript';

export const FormPaynopain = ({ response, testId }) => {
  const { language, translate } = useLocale();

  const [error, setError] = useState();
  const [ready, setReady] = useState();

  useEffect(() => {
    let mounted = true;
    let cleanup;

    (async () => {
      try {
        cleanup = await loadScript({
          domain: 'payments',
          id: SCRIPT_ID,
          src: SCRIPT_URL,
          onLoad: handleLoad,
        });
      } catch (nextError) {
        if (mounted) setError(nextError);
      }
    })();

    return () => {
      mounted = false;
      cleanup && cleanup();
    };
  }, []);

  useEffect(() => {
    if (!response || !ready) return;

    setError();

    const { configuration: { environment, token } = {} } = response;

    (async () => {
      try {
        // eslint-disable-next-line no-undef
        const checkout = await PaylandsCheckout.create({
          environment,
          language: LANGUAGES.includes(language) ? language : 'en',
          token,
        });

        await checkout.render(CONTAINER_ID);
      } catch (nextError) {
        setError(nextError);
      }
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, response]);

  const handleLoad = () => {
    setReady(true);
  };

  return (
    <View testId={testId}>
      <Progress indeterminate visible={!ready && !error} />
      <View id={CONTAINER_ID} className={style.container} testId={testId ? `${testId}-container` : undefined} />
      {error && (
        <Notification error large wide testId={testId ? `${testId}-notification` : undefined}>
          {translate(L10N.NOTIFICATION_ERROR)}
        </Notification>
      )}
    </View>
  );
};

FormPaynopain.displayName = 'Mirai:Payments:ButtonPayment:FormPaynopain';

FormPaynopain.propTypes = {
  response: PropTypes.shape({
    configuration: PropTypes.shape({
      environment: PropTypes.string,
      token: PropTypes.string,
    }),
  }),
  testId: PropTypes.string,
};
